import React, {useMemo} from 'react';
import moment from "moment/moment";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {getTeamShortName} from "../../../utils/SportUtils";
import {useGetNBAPlayerGamesStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";


import './NBAGamesStats.style.scss';
import NBASeasonStats from "./NBASeasonStats";
import GlobalConst from "../../../constants/GlobalConst";
import {getCurrentSeasonYearsBySportAndSeason} from "../../../constants/SportsConst";
import "../PlayerGamesStats.style.scss";
const NBAGamesStats = ({contest}) => {
    const seasonYears = getCurrentSeasonYearsBySportAndSeason(2)
    const player = contest.player;

    const queryArgs = useMemo(() => ({
        playerId: player.PlayerId,
        from: moment().add(-1, 'weeks').toDate().getTime(),
        to: moment().add(1, 'days').endOf('day').toDate().getTime(),
        teamId: player.TeamId
    }), [player.PlayerId, player.TeamId]);

    const {data: gameStats, isLoading} = useGetNBAPlayerGamesStatsByPlayerIdQuery(queryArgs);

    if (!gameStats)
        return <div className={"NoStats"}>No Stats Available</div>

    return <>
        {GlobalConst.FEATURES.SHOW_PLAYER_SEASON_STATS.NBA &&
            <NBASeasonStats playerId={player.PlayerId} seasonYears={seasonYears}/>}
        <div className="NBAgameLogSection">
            <Typography variant="h6" className="gameLogTitle">
                {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.gameLog"}/>
            </Typography>
            <div className="NBAGamesStatsLog">
                <React.Fragment>
                    <div className="GameStats">
                        <div className="tableContainer">
                            <table className={"gameLogTable"}>
                                <thead>
                                <tr>{
                                    <React.Fragment>
                                        <th>Date vs Opp</th>
                                        <th className="highlight gold-gradient-text">PTS</th>
                                        <th>3PM</th>
                                        <th>REB</th>
                                        <th>AST</th>
                                        <th>STL</th>
                                        <th>BLK</th>
                                        <th>TOV</th>
                                        <th>DD2</th>
                                        <th>TD3</th>
                                    </React.Fragment>
                                }</tr>
                                </thead>
                                {gameStats?.filter((game) => moment(game.DateTime).isBefore(moment(), 'day'))
                                    .sort((a, b) => moment(a.DateTime).isBefore(moment(b.DateTime)) ? 1 : -1)
                                    .map((gameStats) => {

                                        let gs = gameStats;
                                        if (!gs)
                                            return null;

                                        return <tbody key={gs.GameId}>
                                        <tr>
                                            {
                                                <React.Fragment>
                                                    <td><span
                                                        className="date">{moment(gameStats.DateTime).format("MM/DD")}</span>
                                                        <span
                                                            className="vs"> vs {getTeamShortName(gameStats.Opponent, "NBAPlayer")} </span>
                                                    </td>
                                                    <td className="highlight gold-gradient-text">{gs.Points}</td>
                                                    <td>{gs.ThreePointsMade}</td>
                                                    <td>{gs.Rebounds}</td>
                                                    <td>{gs.Assists}</td>
                                                    <td>{gs.Steals}</td>
                                                    <td>{gs.Blocks}</td>
                                                    <td>{gs.Turnovers}</td>
                                                    <td>{gs.DoubleDribble}</td>
                                                    <td>{gs.TripleDoubles}</td>
                                                </React.Fragment>
                                            }
                                        </tr>
                                        </tbody>
                                    })}
                            </table>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        </div>
    </>
}

export default NBAGamesStats;